import { useQuery } from "react-query";
import { createApiWithPath } from "../../client";
import { StoryInteractionsResponse } from "../../types/story-interactions";

export interface StoryInteractionFilters {
  status?: string;
  intent?: string;
  token?: string;
  profileId?: string;
  q?: string;
}

export const useStoryInteractions = (filters: StoryInteractionFilters = {}) => {
  return useQuery<StoryInteractionsResponse>(
    ["story-interactions", filters],
    async () => {
      const response = await createApiWithPath("story-interactions").get("", {
        params: filters,
      });
      return response.data;
    },
  );
};
